export default "__VITE_ASSET__a97ba20b__"